import React from 'react';
import { u as useDataListContext } from './DataListContext-CyU4jeBU.js';
import { Link } from 'react-router-dom';
import { s as styles } from './DataList-DeTUdKxc.js';
import { u as useDataListLayoutActionsContext } from './DataListLayoutContext-B-xNSmCX.js';

function DataListItemClickableInternal({ onClick, url, to, children, }) {
    const { activeItem } = useDataListLayoutActionsContext();
    if (!activeItem)
        return React.createElement(React.Fragment, null, children);
    if (to) {
        const computedTo = typeof to === "string" ? to : to(activeItem);
        return (React.createElement(Link, { className: styles.listItemClickable, to: computedTo, onClick: handleClick }, children));
    }
    if (url) {
        const href = typeof url === "string" ? url : url(activeItem);
        return (React.createElement("a", { className: styles.listItemClickable, href: href, onClick: handleClick }, children));
    }
    if (onClick) {
        return (
        // A button can be nested within the list item. To prevent a button inside
        // button error, we need to manually declare a div to be a button
        React.createElement("div", { role: "button", tabIndex: 0, className: styles.listItemClickable, onClick: handleClick, onKeyDown: e => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleClick();
                }
            } }, children));
    }
    return React.createElement(React.Fragment, null, children);
    function handleClick() {
        activeItem && (onClick === null || onClick === void 0 ? void 0 : onClick(activeItem));
    }
}

function DataListItemClickable({ children }) {
    const { itemActionComponent } = useDataListContext();
    if (itemActionComponent) {
        const props = itemActionComponent.props;
        return (React.createElement(DataListItemClickableInternal, Object.assign({}, props), children));
    }
    return React.createElement(React.Fragment, null, children);
}

export { DataListItemClickable as D };
